<p-confirm-dialog [draggable]="false" />
<mon-page-layout
    [header]="'admin.users.page.header' | transloco">
    <div subheader data-test="admin-users-subheader">
        <span>{{ 'admin.users.page.subHeaderText' | transloco}}</span>
        @if (!loadingTotal) {
            <span>{{ 'admin.users.page.subHeaderCount{{availableUsers}}' | transloco: { availableUsers: total } }}</span>
        }
    </div>
    <mon-table-wrapper [value]="users"
                       [headers]="[
                         TABLE_SCHEMA.NAME,
                         TABLE_SCHEMA.EMAIL,
                         TABLE_SCHEMA.LABELS,
                         TABLE_SCHEMA.ROLE,
                         TABLE_SCHEMA.LAST_LOGIN,
                         TABLE_SCHEMA.ACTIONS
                       ]"
                       [total]="total"
                       [currentPage]="page"
                       [perPage]="pageSize"
                       [loading]="loading"
                       [sortBy]="sortBy"
                       [sortDir]="sortDir"
                       [searchText]="searchText"
                       [fixedTableLayout]="false"

                       [filters]="filters"
                       [appliedFilters]="appliedFilters"
                       [filterOrder]="['role', 'label']"

                       [exportConfig]="{
                            buttonLabel: 'admin.users.createExportDialog.buttonLabel' | transloco,
                            payload: {
                                category: 'users_with_domain_access',
                            },
                       }"

                       [searchPlaceholder]="'admin.users.page.searchPlaceholder' | transloco"
                       [exportButtonLabel]="'admin.users.page.exportBtn.label' | transloco"
                       [emptyMessage]="'admin.users.table.emptyMessage' | transloco"
                       [emptySearchMessage]="'admin.users.table.emptySearchMessage' | transloco"
                       (searchInput)="onSearchInput($event)"
                       (filtersApplied)="onFiltersApplied($event)"
                       (loadMoreFilterOptions)="loadMorefilterOptions($event)"
                       (page)="onPageChange($event)"
                       (sort)="sortUsers($event)"

                       tableKey="admin-users">
        <ng-container monTableRight>
            <p-button
                    data-test="admin-users-add-button"
                    [label]="'admin.users.page.addUserBtn.label' | transloco"
                    icon="pi pi-plus"
                    (onClick)="addUser()"
            />
        </ng-container>
        <span monTableCaption>{{ 'List of users' }}</span>
        <ng-container *monTableCellTemplate="TABLE_SCHEMA.NAME; let user">
            <span>{{ user.first_name + (user.last_name ? ' ' + user.last_name : '') }}</span>
        </ng-container>

        <label-select
                *monTableCellTemplate="TABLE_SCHEMA.LABELS; let user"
                (labelAddRequest)="addNewLabelToUser(user, $event)"
                (labelsUpdateRequest)="updateUserLabels(user, $event)"
                (lazyLoad)="labelDataService.fetch($event)"
                (searchLabelInput)="labelDataService.setSearchQuery($event)"
                [(selected)]="user.labels"
                [labels]="labelDataService.labels()"
                [totalLabelsCount]="labelDataService.total()"
                [loading]="labelDataService.fetchingLabels()" />
        <ng-container *monTableCellTemplate="TABLE_SCHEMA.ACTIONS; let user">
            <p-button
                    [ariaLabel]="'admin.users.table.actionMenuBtn.ariaLabel{{userName}}' | transloco:{userName: user.first_name}"
                    data-test="admin-users-actions-button"
                    icon="pi pi-ellipsis-v"
                    [rounded]="true"
                    [text]="true"
                    (onClick)="menu.toggle($event)"
            />
            <p-menu
                    data-test="admin-users-actions-menu"
                    appendTo="body"
                    #menu
                    [model]="user.actionItems"
                    [popup]="true"
                    (onHide)="onMenuHide()"
            />
        </ng-container>
    </mon-table-wrapper>
</mon-page-layout>
